module.exports = __webpack_public_path__ + "img/icon-empty-cart_full.c5eed4e.webp";